// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows:
// 1. Single Responsibility Principle - Fixed system-settings hub entries only
// 2. Separation of Concerns - No coupling to categories API for nav order/labels
// 3. Modular Architecture - Imported by settingsHubNav and docs references
//
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

/**
 * Fixed hub tabs for system setting categories (not derived from GET categories API).
 * Each entry maps to Permission.category / matrix resource on the backend
 * (e.g. qa_context_settings) via readPermission; URL uses system_settings.category
 * (e.g. qa_context) for /settings-category/:category.
 *
 * @type {ReadonlyArray<{
 *   systemCategory: string,
 *   label: string,
 *   readPermission: string,
 *   tabIconKind: string
 * }>}
 */
export const FIXED_SYSTEM_SETTINGS_HUB_ENTRIES = Object.freeze([
  {
    systemCategory: 'qa_context',
    label: 'QA Context Settings',
    readPermission: 'QA_CONTEXT_SETTINGS_READ',
    tabIconKind: 'qa_context_settings',
  },
  {
    systemCategory: 'translation_glossary',
    label: 'Translation Glossary',
    readPermission: 'TRANSLATION_GLOSSARY_READ',
    tabIconKind: 'translation_glossary',
  },
  {
    systemCategory: 'voice_processing',
    label: 'Voice Processing Settings',
    readPermission: 'VOICE_PROCESSING_SETTINGS_READ',
    tabIconKind: 'voice_processing_settings',
  },
]);
